const routeShowcaseSearch = (params = {}) => {
    console.log('Success', params);
    return Promise.resolve(params);
};

export {routeShowcaseSearch};